import styles from "./success.module.scss";
import { Icon } from "@/elements-react/fix-icon";
import success from "@/assets/success-form.svg";
import { t } from "i18next";
import { useIsMobile } from "@/util-react/useIsMobile.ts";
import classNames from "classnames";

export const LeadFormSuccess = () => {
  const isMobile = useIsMobile();

  return (
    <div className={classNames(styles.contentSuccess, (isMobile ? styles.mobile : ""))}>
      <div className={styles.successIcon}>
        <Icon src={success} width={144} height={144} />
      </div>
      <div>
        <div className={styles.title}>{t("n9sir8fvg894wa82.your-request", "Your request has been sent")}</div>
        <div className={styles.subtitle}>{t("aiuysbdfuvaiw38h.our-manager", "Our manager will contact you soon")}</div>
      </div>
    </div>
  );
};
